<div class="main-content table-page table-page--compact publicidad-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Gestión de Publicidad</h1>
        <p>Administre las tarjetas de publicidad del dashboard con una vista compacta y consistente.</p>
      </div>

      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="altaModificarPublicidad(null)">
        <i class="material-icons">add</i>
        <span>Nueva Publicidad</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__table-wrap">
        <table class="table-page__table table-page__table--wide" *ngIf="listaPublicidades.length > 0; else publicidadEmptyState">
          <thead>
            <tr>
              <th>Título</th>
              <th>URL vínculo</th>
              <th>Descripción</th>
              <th>Imagen</th>
              <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of listaPublicidades">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ row.titulo || 'Sin título' }}</strong>
                  <span class="table-page__subtext">ID publicidad activo</span>
                </div>
              </td>
              <td>
                <a *ngIf="row.url; else urlPlaceholder" class="table-page__link" [href]="row.url" target="_blank" rel="noopener">
                  {{ row.url }}
                </a>
                <ng-template #urlPlaceholder>
                  <span class="table-page__subtext">Sin vínculo</span>
                </ng-template>
              </td>
              <td>
                <span class="table-page__text">{{ row.descripcion || 'Sin descripción' }}</span>
              </td>
              <td>
                <img *ngIf="row.imagenConvert; else imagePlaceholder" class="table-page__media-thumb publicidad-page__thumb" [src]="row.imagenConvert" [alt]="row.titulo || 'Publicidad'" />
                <ng-template #imagePlaceholder>
                  <span class="table-page__media-placeholder publicidad-page__thumb-placeholder">
                    <i class="material-icons">image</i>
                  </span>
                </ng-template>
              </td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" (click)="altaModificarPublicidad(row)">
                    <i class="material-icons">edit</i>
                  </button>
                  <button type="button" class="table-page__action-btn table-page__action-btn--danger" (click)="eliminarTarjeta(row)">
                    <i class="material-icons">delete</i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #publicidadEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else publicidadLoadingState">
            <i class="material-icons">campaign</i>
            <strong>No se encontraron tarjetas de publicidad</strong>
            <span>Agregue una nueva tarjeta o intente de nuevo más tarde.</span>
          </div>
        </ng-template>

        <ng-template #publicidadLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando publicidad...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} tarjetas</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">Inicio</button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">Anterior</button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else publicidadPagerEllipsis" type="button" class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>
            <ng-template #publicidadPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">Siguiente</button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">Último</button>
        </div>
      </div>
    </section>
  </div>
</div>
